import React from 'react';
import ListItem from '../ListItem';
import translate from '../../locales';

const __t = translate;


const ParameterPreview = ({ name, positions, groups, emissionProfiles, showEmissionProfiles }) => {
    return (
        <div>
            <div style={{ fontSize: '1.1em', overflowX: 'hidden' }}><strong>{name}</strong></div>
            <div style={{ marginTop: '5px' }}></div>
            <ListItem.ScrollableXList
                label={`${__t('positions')}:`}
                text={positions}
            />
            {showEmissionProfiles && emissionProfiles ?
                <>
                    <div style={{ marginTop: '5px' }}></div>
                    <ListItem.ScrollableXList
                        label={`${__t('emission_profiles')}:`}
                        text={emissionProfiles}
                    />
                </>
                :
                null
            }
            {groups ?
                <>
                    <div style={{ marginTop: '5px' }}></div>
                    <ListItem.ScrollableXList
                        label={`${__t('groups')}:`}
                        text={groups}
                    />
                </>
                :
                null
            }
        </div>
    )
}

export default ParameterPreview;